import { AppStatusBadge } from "@shared/components/ui/status-badge/AppStatusBadge"

interface CustomerTypeBadgeProps {
  type: "individual" | "business"
  className?: string
}

export function CustomerTypeBadge({ type }: CustomerTypeBadgeProps) {
  return (
    <AppStatusBadge
      variant="generic"
      text={type === "business" ? "Business" : "Individual"}
      color={type === "business" ? "info" : "neutral"}
      size="sm"
    />
  )
}
